<template>
  <div class="row">
    <div class="mb-0" :class="leftSideClass">
      <title-bread-crumb :page="page" />
    </div>
    <div
      class="d-flex justify-content-end align-items-center actions"
      :class="rightSideClass"
    >
      <slot name="custom_actions" />
      <action-button
        v-if="hasReturn"
        i="fas fa-arrow-circle-left"
        variant="outline-success m-2"
        @click="onReturn"
      >
        Regresar
      </action-button>
      <action-button
        v-if="hasSave"
        :i="`fas fa-save pr-1`"
        variant="success"
        @click="save"
      >
        Guardar
      </action-button>
      <action-button
        v-if="hasAdd"
        :i="`fas fa-file-plus pr-1`"
        variant="success"
        @click="add"
      >
        {{ addText }}
      </action-button>
      <action-button
        v-if="hasSubmit"
        :disabled="submitDisabled"
        :i="`fas fa-save pr-1`"
        variant="success"
        @click="submit"
      >
        Someter
      </action-button>
      <!-- De aqui en adelante esto no deberia estar aqui --->
      <action-button
        v-if="hasPrint"
        class="m-2"
        :disabled="printDisabled"
        :i="`fas fa-print pr-1`"
        variant="success"
        @click="print"
      >
        Imprimir
      </action-button>
      <action-button
        v-if="hasInfo"
        class="m-2 btn btn-dropdown-actions px-4"
        :disabled="infoDisabled"
        :iright="'fas fa-angle-down'"
        variant="success"
        @click="info"
      >
        Informes
      </action-button>
      <action-button
        v-if="hasAssingProposal"
        class="m-2"
        :disabled="assignProposalDisabled"
        :i="`fas fa-clone pr-1`"
        variant="success"
        @click="assignProposal"
      >
        Asignar Propuestas
      </action-button>
      <action-button
        v-if="hasEvaluators"
        :disabled="evaluatorsDisabld"
        :i="`fas fa-users pr-1`"
        variant="success m-2 pr-3"
        @click="evaluators"
      >
        Evaluadores
      </action-button>
      <action-button
        v-if="hasContinue"
        i="fas fa-arrow-circle-right pr-1"
        variant="success"
        @click="onContinue"
      >
        Continuar
      </action-button>
    </div>
    <div class="col-12 p-0">
      <div class="dropdown-divider mt-0 pb-2 w-102 mb-4 ml-n5 mr-n5" />
    </div>
  </div>
</template>

<script>
import TitleBreadCrumb from '@/components/common/page/TitleBreadcrumb';
import { ActionButton } from '@/components/common';

export default {
  components: {
    TitleBreadCrumb,
    ActionButton,
  },

  props: {
    page: {
      type: Object,
      default: () => {},
    },
    hasReturn: {
      type: Boolean,
      default: () => false,
    },
    hasSave: {
      type: Boolean,
      default: () => false,
    },
    hasSubmit: {
      type: Boolean,
      default: () => false,
    },
    hasPrint: {
      type: Boolean,
      default: () => false,
    },
    hasAdd: {
      type: Boolean,
      default: () => false,
    },
    hasInfo: {
      type: Boolean,
      default: () => false,
    },
    hasAssingProposal: {
      type: Boolean,
      default: () => false,
    },
    hasEvaluators: {
      type: Boolean,
      default: () => false,
    },
    hasContinue: {
      type: Boolean,
      default: () => false,
    },
    submitDisabled: {
      type: Boolean,
      default: () => false,
    },
    printDisabled: {
      type: Boolean,
      default: () => false,
    },
    stickyButtons: {
      type: Boolean,
      default: () => false,
    },
    addText: {
      type: String,
      default: () => 'Añadir',
    },
    assignProposal: {
      type: Function,
      default: () => false,
    },
    leftSideClass: {
      type: String,
      default: () => 'col-xl-8',
    },
    rightSideClass: {
      type: String,
      default: () => 'col-xl-4',
    },
  },
  methods: {
    add() {
      this.$emit('onAdd');
    },
    save() {
      this.$emit('onSave');
    },
    onReturn() {
      this.$emit('onReturn');
    },
    submit() {
      this.$emit('onSubmit');
    },
    print() {
      this.$emit('onPrint');
    },
    onContinue() {
      this.$emit('onContinue');
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 870px) {
  .actions {
    display: block !important;
  }

  .actions button {
    margin-bottom: 10px;
  }
}
</style>
